import {Component, OnInit} from '@angular/core';
import {Student} from "@tva/ng-migration/student/models/student.model";
import {SearchDetailsNotificationService} from "@tva/ng-migration/student/services/search-details-notification.service";

@Component({
    selector: 'app-student-cre-summary-header',
    templateUrl: './summary-header.component.html',
    styleUrls: ['./summary-header.component.scss']
})
export class SummaryHeaderComponent implements OnInit {
    student: Student;

    constructor(private searchUpdate: SearchDetailsNotificationService) {
    }

    ngOnInit(): void {
        this.loadData();
    }

    loadData(): void {
        this.searchUpdate.studentObservable.subscribe((student) => {
            this.student = student;
        });
    }

}
